import React from 'react';
import {
    Drawer,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerTitle,
} from '../ui/drawer.js';
import { cn } from '../../utils.js';

interface MemoraiDrawerProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title?: string;
    description?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    className?: string;
    contentClassName?: string;
    showHandle?: boolean;
    showOverlay?: boolean;
    titleHidden?: boolean;
    modal?: boolean;
    noBodyStyles?: boolean;
}

export const MemoraiDrawer: React.FC<MemoraiDrawerProps> = ({
    open,
    onOpenChange,
    title,
    description,
    children,
    footer,
    className,
    contentClassName,
    showHandle = true,
    showOverlay = true,
    titleHidden = false,
    modal = true,
    noBodyStyles = false,
}) => (
    <Drawer open={open} onOpenChange={onOpenChange} modal={modal} noBodyStyles={noBodyStyles}>
        <DrawerContent
            className={cn('rounded-t-[2.5rem] border-foreground/10 border-t-0 p-0 z-[150]', className)}
            showOverlay={showOverlay}
            translate="yes"
        >
            {showHandle && <div className="w-12 h-1.5 bg-foreground/10 rounded-full mx-auto my-4 shrink-0" />}

            <div className={cn('min-h-0 flex-1 overflow-y-auto p-8 pt-2', contentClassName)} role="document">
                {titleHidden && title && !description && <DrawerTitle className="sr-only">{title}</DrawerTitle>}
                {(!titleHidden || description) && (title || description) && (
                    <div className="mb-8 text-left space-y-1">
                        {title && (
                            <DrawerTitle className={titleHidden ? 'sr-only' : 'text-2xl font-bold text-foreground'}>
                                {title}
                            </DrawerTitle>
                        )}
                        {description && (
                            <DrawerDescription className="text-foreground-subtle text-sm">
                                {description}
                            </DrawerDescription>
                        )}
                    </div>
                )}
                {children}
            </div>
            {footer && <DrawerFooter className="px-8 pt-4">{footer}</DrawerFooter>}
        </DrawerContent>
    </Drawer>
);
